module.exports = __webpack_public_path__ + "static/media/main_banner.03268939.png";